// context/SocketContext.tsx
import { createContext } from 'react'
import { Socket } from 'socket.io-client'

export const SocketContext = createContext<Socket | undefined>(undefined)
